<template>
  <card class="wrapper-order">
    <div class="order-info">
      <el-image
        style="
          width: 100px;
          border-radius: 8px;
          height: 100px;
          margin-right: 20px;
        "
        :src="detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : ''"
        :preview-src-list="[detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : '']"
      >
        <div
          style="
            background: #f5f7fa;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #c0c4cc;
          "
          slot="error"
        >
          暂无图片
        </div>
      </el-image>

      <div class="order-info-right">
        <div class="order-title">
          <span class="fw700 mr10">{{ detailInfo.orderGoods ? detailInfo.orderGoods.skuTitle : "" }}</span>
          <el-tag type="primary" effect="plain">
            {{ detailInfo.orderGoods ? detailInfo.orderGoods.goodsPurityName : "" }}
          </el-tag>
          <el-tag type="primary" effect="plain">{{ detailInfo.orderTypeName }}</el-tag>
        </div>
        <div class="label">
          订单号：{{ $route.params.id }}
          <el-tag type="primary" effect="plain">{{ detailInfo.statusName }}</el-tag>
        </div>
        <div class="label">下单时间：{{ detailInfo.createTime }}</div>
      </div>
    </div>

    <div>
      <AdminTitle title="费用明细" size="15px" bottom="5px"/>
      <card class="wrapper-order special-card">
        <el-row>
          <el-col
              :span="item.width ? item.width : 8"
              v-for="(item, index) in orderInfoList"
              :key="index"
          >
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ detailInfo[item.prop] || "-" }}{{ item.unit }}</span>
            <!-- 门店结算 -->
            <i
                v-if="item.prop == 'storeSettleAmount' && showStoreSettleBtn"
                :disabled="!detailInfo.store || !isShowBtn(AUTH_BTN.order_list_detail_store_calc)"
                @click="startCalc"
                class="el-icon-edit"
            >
              {{ storeCalcBtnName }}
            </i>
          </el-col>
        </el-row>
      </card>
    </div>

    <!-- 门店金额结算 -->
    <el-dialog
        class="store-settle-dialog"
        title="门店结算"
        :visible.sync="showStoreCalcDialog"
        width="600px"
    >
      <el-form
          class="store-settle-box"
          ref="storeForm"
          :model="storeCalcFormData"
          label-width="140px"
      >
        <el-form-item label="订单号：">{{ this.$route.params.id }}</el-form-item>
        <el-form-item label="商品信息：">{{ storeCalcResult.goodsTitle }}</el-form-item>
        <el-form-item label="采购价：">￥{{ storeCalcResult.costAmount }}</el-form-item>
        <el-form-item label="客户首付款：">
          <div class="row-box">
            <span> ￥{{ storeCalcResult.prepayAmount }} </span>
            <el-switch
              v-if="storeCalcBtnName == '录入'"
              v-model="storeCalcFormData.prepayPayeeType"
              class="custom-switch"
              :active-value="1"
              active-text="平台收取"
              :inactive-value="2"
              inactive-text="门店代收"
              active-color="#409EFF"
              inactive-color="#67C23A"
              @change="refreshCalcResult"
            />
            <span v-else>({{ ["平台收取", "门店收取"][storeCalcFormData.prepayPayeeType - 1] }})</span>
          </div>
        </el-form-item>
        <el-form-item label="监管服务费：">
          <div class="row-box">
            <span> ￥{{ storeCalcResult.lockAmount }} </span>
            <el-switch
                v-if="storeCalcBtnName == '录入'"
                v-model="storeCalcFormData.lockPayeeType"
                class="custom-switch"
                :active-value="1"
                active-text="平台收取"
                :inactive-value="2"
                inactive-text="门店代收"
                active-color="#409EFF"
                inactive-color="#67C23A"
                @change="refreshCalcResult"
            />
            <span v-else>({{ ["平台收取", "门店收取"][storeCalcFormData.lockPayeeType - 1] }})</span>
          </div>
        </el-form-item>
        <el-form-item label="返点奖励：" v-if="Number(storeCalcResult.rewardAmount) > 0">
          <span> ￥ {{ storeCalcResult.rewardAmount }} </span>
        </el-form-item>
        <el-form-item label="门店待结算金额：">
          <span class="calc-money"> ￥ {{ storeCalcResult.settleAmount }} </span>
        </el-form-item>
        <el-form-item label="门店收款信息：">
          <div v-if="storeCalcResult.settleType == 2">
            <p>姓名：{{ storeCalcResult.store ? storeCalcResult.store.payeeIdName : "" }}</p>
            <p>支付宝账号：{{ storeCalcResult.store ? storeCalcResult.store.payeeAlipayAccount : "" }}</p>
          </div>
          <div v-else>线下打款</div>
        </el-form-item>
        <el-form-item label="" label-width="0" v-if="storeCalcBtnName == '录入'">
          <div style="text-align: center; padding-top: 20px">
            <el-button type="primary" size="medium" @click="submitCalc">保 存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </card>
</template>

<script>
import {calcSettleAPI, getSettleInfoAPI, saveSettleAPI} from "@/views/order/order-list/modules/api";
import {authBtnMixin} from "@/mixins/authBtnMixin";

export default {
  name: "OrderInfo",
  mixins: [authBtnMixin],
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  inject: ["reload"],

  data() {
    return {
      priceData: {
        salePrice: "",
        orderNo: "",
      },
      priceRateDialog: false,
      storeComboList: [],
      storeComboData: {
        orderNo: "",
        storeComboId: "",
      },
      orderInfoList: [
        {
          label: "总租金：",
          prop: "rentPrice",
          unit: "元",
        },
        {
          label: "到期申请购买价：",
          prop: "buyoutPrice",
          unit: "元",
        },
        {
          label: "方案：",
          prop: "storeComboName",
        },
        {
          label: "总期数：",
          prop: "billPeriodNum",
          unit: "期",
        },
        {
          label: "监管服务费：",
          prop: "lockAmount",
          unit: "元",
        },
        {
          label: "零售价：",
          prop: "salePrice",
          unit: "元",
        },
        {
          label: "首付租金：",
          prop: "prepayRentPrice",
          unit: "元",
        },
        {
          label: "意外保：",
          prop: "insurancePrice",
          unit: "元",
        },
        {
          label: "门店结算：",
          prop: "storeSettleAmount",
          unit: "元",
        },
      ],
      storeCalcFormData: {
        orderNo: this.$route.params.id,
        prepayPayeeType: 1,
        lockPayeeType: 1,
      },
      storeCalcResult: {
        orderNo: "",
        goodsTitle: "",
        costAmount: "",
        prepayAmount: "",
        prepayPayeeType: 1,
        lockAmount: "",
        lockPayeeType: 1,
        settleAmount: "",
      },
      showStoreCalcDialog: false,
    };
  },

  computed: {
    storeCalcBtnName() {
      return [1, 2, 3, 4].includes(this.detailInfo.status) ? "录入" : "详情";
    },

    showStoreSettleBtn() {
      return this.detailInfo.status > 1;
    },
  },

  methods: {
    async refreshCalcResult() {
      let res = await calcSettleAPI({
        orderNo: this.$route.params.id,
        prepayPayeeType: this.storeCalcFormData.prepayPayeeType,
        lockPayeeType: this.storeCalcFormData.lockPayeeType,
      });
      this.storeCalcResult = { ...this.storeCalcResult, ...res };
    },

    //录入
    async startCalc() {
      this.storeCalcResult = await getSettleInfoAPI({
        orderNo: this.$route.params.id,
      });
      this.showStoreCalcDialog = true;
      this.storeCalcFormData = { ...this.storeCalcFormData, ...this.storeCalcResult };
    },

    // 保存
    async submitCalc() {
      await saveSettleAPI(this.storeCalcFormData);
      this.showStoreCalcDialog = false;
      this.$emit('update:flag', true);
      this.$emit('updateDetail');
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-order ::v-deep {
  border-color: transparent;
  width: 100%;
  border-radius: 16px;
  color: #222222;

  .label {
    color: #666666;
    font-size: 14px;
  }

  .ivu-card {
    border-radius: 18px;
  }

  .order-info {
    display: flex;
    margin-bottom: 10px;

    .order-info-right {
      display: flex;
      flex-direction: column;

      .order-title {
        color: #333333;
        font-size: 18px;
      }

      .label {
        margin-top: 8px;
        font-size: 12px;
      }
    }

    .el-tag {
      height: 25px;
      border-radius: 15px;
      margin-right: 5px;
      line-height: 25px;
    }
  }

  .el-dialog__footer {
    padding-bottom: 30px !important;
  }

  .store-settle-dialog {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .store-settle-box {
      .el-select {
        margin-left: 5px;
      }
    }
  }
}

.special-card {
  background: #f7f8fa;
  line-height: 35px;
  color: #222222;
  position: relative;

  .value {
    margin-left: 15px;
    min-width: 80px;
    display: inline-block;
    font-weight: 700;
  }

  .label {
    text-align: right;
    min-width: 100px;
    display: inline-block;
  }

  .el-icon-edit {
    margin-left: 10px;
    cursor: pointer;
    color: #4badf8;
  }

  .el-button {
    border-radius: 20px;
    margin-left: 10px;
  }
}

.fw700 {
  font-weight: 700;
}

.mr10 {
  margin-right: 10px;
}

:deep(.custom-switch .el-switch__label) {
  position: absolute;
  display: none;
  color: #fff !important;
  font-size: 13px !important;
  z-index: 2;
}

/* 开启时文字位置 */
:deep(.custom-switch .el-switch__label--right) {
  right: -8px;
}

/* 关闭时文字位置 */
:deep(.custom-switch .el-switch__label--left) {
  left: 22px;
}

/* 显示激活状态的文字 */
:deep(.custom-switch .el-switch__label.is-active) {
  display: block;
}

/* 调整开关宽度以适应文字 */
:deep(.custom-switch .el-switch__core),
:deep(.custom-switch .el-switch__label) {
  width: 85px !important;
  height: 20px !important;
}
</style>
